
(function() {
  // Only run on article pages
  if (!document.querySelector('.main-blog-post')) return;

  const content = document.querySelector('.blog-post-content') || document.querySelector('[data-testid="blog-post-content"]');
  if (!content) return;

  // Find the article's parent container
  const articleSection = document.querySelector('.main-blog-post') || content.closest('section');
  if (!articleSection) return;

  // Get all H2 headings from the article
  const headings = content.querySelectorAll('h2');
  if (headings.length < 2) return; // No TOC needed for short articles

  // Add IDs to headings for anchor linking
  headings.forEach((h, i) => {
    const id = h.textContent.trim().toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .substring(0, 50);
    h.id = id || 'section-' + i;
  });

  // Create sidebar HTML
  const sidebar = document.createElement('aside');
  sidebar.className = 'article-sidebar';
  sidebar.innerHTML = `
    <div class="sidebar-inner">
      <div class="sidebar-toc">
        <h4 class="sidebar-title">In This Article</h4>
        <nav>
          <ul class="toc-list">
            ${Array.from(headings).map(h => 
              '<li><a href="#' + h.id + '" class="toc-link" data-target="' + h.id + '">' + h.textContent.trim() + '</a></li>'
            ).join('')}
          </ul>
        </nav>
      </div>
      <div class="sidebar-cta">
        <p class="cta-label">Ready to find yours?</p>
        <a href="/collections/all" class="cta-button">Shop Now</a>
        <a href="/pages/size-quiz" class="cta-link">or Take the Size Quiz →</a>
      </div>
    </div>
  `;

  // Create wrapper for the layout
  const wrapper = document.createElement('div');
  wrapper.className = 'article-layout';

  // Get the content blocks (title, details, content) 
  const children = Array.from(articleSection.children);
  const innerWrap = articleSection.querySelector('.section__inner') || articleSection;
  
  // Wrap existing content
  const contentWrapper = document.createElement('div');
  contentWrapper.className = 'article-main';

  // Move all existing children into contentWrapper
  const inner = innerWrap.querySelector('.section-blocks') || innerWrap;
  while (inner.firstChild) {
    contentWrapper.appendChild(inner.firstChild);
  }

  // Build layout: content + sidebar
  wrapper.appendChild(contentWrapper);
  wrapper.appendChild(sidebar);
  inner.appendChild(wrapper);

  // Sticky TOC: highlight active section on scroll
  const tocLinks = sidebar.querySelectorAll('.toc-link');
  
  function updateActiveLink() {
    let current = '';
    headings.forEach(h => {
      const rect = h.getBoundingClientRect();
      if (rect.top <= 120) {
        current = h.id;
      }
    });
    tocLinks.forEach(link => {
      link.classList.toggle('active', link.dataset.target === current);
    });
  }

  window.addEventListener('scroll', updateActiveLink, { passive: true });
  updateActiveLink();

  // Smooth scroll for TOC links
  tocLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.getElementById(this.dataset.target);
      if (target) {
        const y = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  });
})();
